import type {
  ToothBasisSeriesFrame,
  ToothBasisSeriesName,
} from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import {
  DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES,
  TOOTH_BASIS_SERIES_ORDER,
  TOOTH_BASIS_SERIES_TO_GROUP,
  type FullHeadMprSliceGroupView,
  type FullHeadMprSliceTileView,
  type ToothBasisSeriesView,
  type ToothSliceOptionsBySeries,
} from '../config';

import { makeFullHeadMprSliceTileID } from './fullHeadMprSliceTileID';

export const makeFullHeadMprSliceGroups = ({
  frames,
  pendingSeries = [],
  series,
  slabThicknessMm,
  sliceOptions = DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES,
  sliceStepMm,
  toothID,
}: {
  frames: Record<ToothBasisSeriesName, ToothBasisSeriesFrame> | null;
  series: ToothBasisSeriesView | null;
  slabThicknessMm: Record<ToothBasisSeriesName, number> | null;
  sliceStepMm: Record<ToothBasisSeriesName, number> | null;
  toothID: string;
  pendingSeries?: ToothBasisSeriesName[];
  sliceOptions?: ToothSliceOptionsBySeries;
}): FullHeadMprSliceGroupView[] => {
  if (!frames || !series || !slabThicknessMm || !sliceStepMm) {
    return [];
  }

  return TOOTH_BASIS_SERIES_ORDER.reduce<FullHeadMprSliceGroupView[]>(
    (groups, seriesName) => {
      const frame = frames[seriesName];
      const tileViews = series[seriesName];

      if (!frame || !tileViews?.length) {
        return groups;
      }

      const tiles: FullHeadMprSliceTileView[] = tileViews.map(
        (tile, index) => ({
          kind: 'series',
          id: makeFullHeadMprSliceTileID({
            offsetMm: tile.offsetMm,
            seriesName,
            sliceStepMm: sliceOptions[seriesName].sliceStepMm,
            toothID,
          }),
          offsetMm: tile.offsetMm,
          order: index,
          pngUrl: tile.pngUrl,
          seriesName,
        }),
      );

      return [
        ...groups,
        {
          frame,
          groupName: TOOTH_BASIS_SERIES_TO_GROUP[seriesName],
          options: sliceOptions[seriesName],
          isPending: pendingSeries.includes(seriesName),
          seriesName,
          slabThicknessMm: slabThicknessMm[seriesName],
          sliceStepMm: sliceStepMm[seriesName],
          tiles,
        },
      ];
    },
    [],
  );
};
